import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import 'antd/dist/antd.css';
import { Layout, Menu } from 'antd';
import {
  ContainerOutlined,
  TagOutlined,
  DashboardOutlined
} from '@ant-design/icons';
import TramittaLogoWhite from '../images/tramitta-logo-white.png';

/**
 * Component that returns a Steps with document history.
 * @component
 * @returns {Element} Sider with options according to each user role
 */
const Sider = () => {
  const { Sider } = Layout;
  const { pathname } = useLocation();
  const [selectedKey, setSelectedKey] = useState(['0']);

  useEffect(() => {
    (pathname.includes('/contracts')) && setSelectedKey(['0']);
    (pathname.includes('/coupons')) && setSelectedKey(['1']);
    (pathname.includes('/dashboard')) && setSelectedKey(['2']);
  }, [pathname]);

  const adminSider = [
    {
      icon: <ContainerOutlined />,
      navLink: '/contracts',
      label: 'Contratos de arriendo',
    },
    {
      icon: <TagOutlined />,
      navLink: '/coupons',
      label: 'Códigos promocionales',
    },
    {
      icon: <DashboardOutlined />,
      navLink: '/dashboard',
      label: 'Panel',
    },
  ];

  return (
    <Sider
      breakpoint="lg"
      collapsedWidth="0"
    >
      <div className="logo-container">
        <img src={TramittaLogoWhite} alt="tramitta logo" className="logo-sider" />
      </div>
      <Menu
        theme="dark"
        mode="inline"
        defaultSelectedKeys={['0']}
        selectedKeys={selectedKey}
        onClick={({ keyPath }) => (setSelectedKey(keyPath))}
      >
        {adminSider.map((sider, index) => (
          <Menu.Item key={index} icon={sider.icon}>
            <NavLink to={sider.navLink}>{sider.label}</NavLink>
          </Menu.Item>
        ))}
      </Menu>
    </Sider>
  );
};

export default Sider;